import React from "react"
import { Link } from "react-router-dom"
import { Grid, Typography } from "@material-ui/core"

import TagChip from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/TagChip"

import { renderChatBotTriggerIcon } from "@/utils/chatBot"

import { ChatBotCategory } from "@/protocols/chatBot"
import { WebhookTemplateType } from "@/protocols/webhook"

import { ShortChatBotFlow } from "@/services/ChatBotFlow"

import useStyles from "@/pages/Admin/Flow/FlowList/FlowListItem/FlowListItemTrigger/styles"

type FlowListItemTriggerProps = {
	chatBotFlow: Pick<ShortChatBotFlow, "id" | "name" | "active" | "updated_at" | "consolidated_data" | "tag" | "board">
	chatBotCategory: ChatBotCategory | undefined
	webhookTemplateType?: WebhookTemplateType | "custom" | undefined
	flowEditorPath: string
}

type TriggerInfo = Record<ChatBotCategory, {
	label: string
	color: {
		r: number
		g: number
		b: number
	}
	name: string
} | null>

const DEFAULT_RGB_CHIP_COLOR = {
	r: 53,
	g: 140,
	b: 238
}

const FlowListItemtrigger: React.FC<FlowListItemTriggerProps> = (props) => {
	const {
		chatBotCategory,
		webhookTemplateType,
		flowEditorPath,
		chatBotFlow
	} = props

	const classes = useStyles()

	const isShowAditionalSpacing = chatBotCategory === "client-added-to-funnel-stage" || chatBotCategory === "client-tag-associated"

	const renderTriggerInfo = () => {
		const triggerConfig: TriggerInfo = {
			"client-tag-associated": {
				label: "Tag:",
				color: chatBotFlow?.tag?.color || DEFAULT_RGB_CHIP_COLOR,
				name: chatBotFlow?.tag?.name || "Nenhuma Tag Associada"
			},
			"client-added-to-funnel-stage": {
				label: "Etapa:",
				color: DEFAULT_RGB_CHIP_COLOR,
				name: chatBotFlow?.board?.stage.name || "Nenhuma Etapa Associada"
			},
			"attendance-finished": null,
			"attendance-started-by-client": null,
			"attendance-taken": null,
			"no-triggers": null,
			"webhook-triggered": null
		}

		const triggerInfo = triggerConfig[chatBotCategory || "no-triggers"]

		if (!triggerInfo) {
			return null
		}

		return (
			<Grid container spacing={1} className={classes.triggerInfo}>
				<Grid item>
					<Typography className={classes.tagAssociatedTriggerTitle}>
						{triggerInfo.label}
					</Typography>
				</Grid>

				<Grid item style={{ width: "100%" }}>
					<TagChip
						color={triggerInfo.color}
						name={triggerInfo.name}
						className={classes.textOverflow}
						{...(triggerInfo.name.length > 25 && {
							tooltip: { name: triggerInfo.name }
						})}
					/>
				</Grid>
			</Grid>
		)
	}

	return (
		<Grid container spacing={2} alignItems="center">
			<Grid item>
				<Grid container justifyContent="center">
					{renderChatBotTriggerIcon(chatBotCategory, webhookTemplateType || "custom")}
				</Grid>
			</Grid>
			<Grid item xs={10}>
				<Grid container direction="column" justifyContent="center" spacing={isShowAditionalSpacing ? 1 : 0}>
					<Grid item xs={12}>
						<Link to={flowEditorPath} style={{ textDecoration: "none" }}>
							<Typography variant="h4" className={classes.listItemTitle}>
								{chatBotFlow.name}
							</Typography>
						</Link>
					</Grid>

					<Grid item>
						{renderTriggerInfo()}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default FlowListItemtrigger
